"use client";

import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  const [isLoaded, setIsLoaded] = useState(false);
  const imageRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setIsLoaded(true);
  }, []);
  return <section id="hero" className="relative min-h-screen flex items-center overflow-hidden bg-background">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-0 items-center">
          {}
          <div className="relative z-10 py-16 lg:py-24 lg:pr-16">
            <div className="space-y-8 max-w-xl">
              <h1 className={`font-display text-5xl sm:text-6xl lg:text-7xl text-foreground leading-[1.1] transition-all duration-slow ease-spring ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
              transitionDelay: "100ms"
            }}>
                Discover
                <br />
                <span className="text-primary-dark">Eco‑Luxury</span>
                <br />
                Adventures
              </h1>

              <p className={`text-lg sm:text-xl text-muted-foreground leading-relaxed transition-all duration-slow ease-spring ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
              transitionDelay: "200ms"
            }}>
                Exclusive experiences blending Caribbean elegance, cultural
                heritage, and pristine nature in Riviera Maya
              </p>

              <div className={`flex flex-wrap gap-4 transition-all duration-slow ease-spring ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
              transitionDelay: "300ms"
            }}>
                <Link to="/ContactPage">
                  <Button size="lg" variant="outline" className="text-primary-dark border-primary/30 hover:bg-primary/10 hover:border-primary/50">
                    Contact Us
                  </Button>
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="relative lg:absolute lg:right-0 lg:top-0 lg:bottom-0 lg:w-1/2 h-[60vh] lg:h-full">
            <div ref={imageRef} className={`absolute inset-0 bg-cover bg-center transition-transform duration-[8000ms] ease-out ${isLoaded ? "scale-105" : "scale-100"}`} style={{
            backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549040/img/riviera_maya_turquoise_coast.png)",
            clipPath: "ellipse(100% 100% at 100% 50%) path('M 0,0 Q 50,100 100,100 Q 150,100 200,0 Z')",
            borderRadius: "0 0 0 50% / 0 0 0 30%"
          }} />
            <div className="absolute inset-0" style={{
            background: "linear-gradient(to right, hsla(0, 0%, 100%, 0.3) 0%, transparent 50%)",
            clipPath: "ellipse(100% 100% at 100% 50%) path('M 0,0 Q 50,100 100,100 Q 150,100 200,0 Z')",
            borderRadius: "0 0 0 50% / 0 0 0 30%"
          }} />
          </div>
        </div>
      </div>
    </section>;
}